import React from "react";
import {Link} from "react-router-dom";
import '../assets/css/accordion.css';


function Accordion(props) {

  return (
    <>
      <div className="card mb-3">
        <div
          className={`card-header border-0 ${props.headerStatus ? props.headerStatus : ''}`}
          data-toggle="collapse"
          data-target={`#collapse${props.accordionNumber}`}
          aria-expanded={props.ariaExpanded}
          aria-controls={`collapse${props.accordionNumber}`}
        >
          <div className="panel-title">
            <h5 className="mb-0 d-flex justify-content-between fnt-inter-mdum accordion-question">
              {props.title}
            </h5>
          </div>
        </div>
        <div id={`collapse${props.accordionNumber}`} className={`collapse ${props.collapse ? props.collapse : ''}`} data-parent="#accordian">
          <div className="card-body p-0" style={{ color: "#6B7280" }}>
            {props.description}
          </div>
        </div>
      </div>
    </>
  );
}

export default Accordion;
